import { Routes } from '@angular/router';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { LoginComponent } from './login/login.component';
import {EnterTwoFactorComponent} from './login/enter-two-factor/enter-two-factor.component';

export const authorizationRoutes: Routes = [
    { path: 'login', component: LoginComponent },
    { path: 'enter-2fa', component: EnterTwoFactorComponent },
    { path: 'forgot-password', component: ForgotPasswordComponent },
    { path: 'confirm/:id', component: ConfirmEmailComponent },
    { path: 'reset-password/:id/:token', component: ResetPasswordComponent },
];
